import React from "react";
import { TFunction } from "i18next";
import { IObservationPackage } from "../../interfaces/ObservationPackage/ObservationPackage";
import { useHistoryPackage } from "../../data/observation/useHistoryPackage";
import { Divider, Message, Segment } from "semantic-ui-react";
import ObservationDetail from "./ObservationDetail";
import SchemaDisplay from "../SchemaDisplay";
import { useUserCanViewNames } from "../../store/selectors/appRoleSelector";

const getTextProps = (t: TFunction) => ({

});

interface ObservationPackageDetailsContentProps {
    data: IObservationPackage;
}

const ObservationPackageDetailsContent: React.FC<ObservationPackageDetailsContentProps> = ({ data }) => {
    const canViewNames = useUserCanViewNames(data.category.id);

    if (!data.observation.formSchema) {
        return (
            <Message content="Missing form configuration" />
        )
    }
    return (
        <>
            <ObservationDetail observation={data.observation} showNameDetail={canViewNames} hiddenDivider onlyStaticData />
            <Divider hidden />
            <SchemaDisplay
                formSchema={data.observation.formSchema}
                formData={{ ...data.observation.formData }}
                canViewNames={canViewNames}
            />
        </>
    );
};





interface ObservationPackageDetailsProps {
    packageId: string;
}

const ObservationPackageDetails: React.FC<ObservationPackageDetailsProps> = ({ packageId }) => {
    const { data } = useHistoryPackage(packageId);
    if (!data) {
        return <Segment loading placeholder basic />
    }
    return (
        <ObservationPackageDetailsContent
            data={data}
        />
    );
};


export default ObservationPackageDetails;
